import qs from 'qs'
import {httpClient} from '../../../services'

export function getHomeList (params) {
  return httpClient.get('/tools/v1/diet/categories', {params})
}

export function getArticleList (params) {
  return httpClient.get('/tools/v1/diet/articles', {
    params
  })
}

export function getAddContent (data) {

  return httpClient({
    url: '/Index/Feedback/add',
    method: 'post',
    baseURL: process.env.API_TRHIRD || 'https://third.doctopia.com.cn',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })
}

export function getArticle (params) {
  const { id, ...other } = params
  return httpClient.get(`/tools/v1/diet/articles/show/${id}`, {
    params: other
  })
}

export function getUnionid () {
  return httpClient.get('/tools/v1/get/unionid')
}
